<div class="modal-backdrop" (click)="goBack()"></div>

<div class="invoice" *ngIf="jobItem">

  <!-- Top bar -->
  <div class="inv-bar">
    <span class="inv-badge" *ngIf="invoice"
      [ngClass]="{'inv-badge--paid': invoice?.status == 'paid', 'inv-badge--unpaid': invoice?.status == 'unpaid'}">
      {{ invoice.status }}
    </span>
    <button class="inv-close" (click)="goBack()"><i class="fa fa-times"></i></button>
  </div>

  <!-- Scroll -->
  <div class="inv-scroll">

    <!-- Hero -->
    <div class="inv-hero">
      <span class="inv-ref" *ngIf="invoice?.serialNo">Invoice #{{ invoice.serialNo }}</span>

      <div class="inv-amount-block" *ngIf="invoice">
        <span class="inv-amount"><span class="inv-dollar">$</span>{{ invoice.total }} <span class="inv-currency">{{ invoice.currency }}D</span></span>
      </div>

      <!-- Payment date -->
      <div class="inv-sched" *ngIf="invoice?.staffyPayScheduledDate && invoice?.status === 'unpaid'">
        <i class="fas fa-clock"></i>
        <span>You'll be paid on <strong>{{ formattedScheduledDate }}</strong></span>
      </div>
    </div>

    <!-- Receipt tear -->
    <div class="inv-tear"></div>

    <!-- Shift card -->
    <div class="sc">
      <div class="sc__left">
        <div class="sc__avatar">
          <img [src]="profilePicture">
        </div>
        <div class="sc__stripe"></div>
      </div>
      <div class="sc__right">
        <span class="sc__company">{{ invoice?.entity?.name || jobItem.entity?.name }}</span>
        <span class="sc__role">{{ ('SKILLS.' + jobItem?.skill) | translate }}</span>
        <span class="sc__unit" *ngIf="jobItem.unitNumber">Unit {{ jobItem.unitNumber }}</span>
        <span class="sc__when">{{ jobItem.shiftStartTimeFormatted }}<span *ngIf="!jobItem.isVisitBasedShift"> · <strong>{{ jobItem.startTime }} – {{ jobItem.endTime }}</strong></span></span>
      </div>
    </div>

    <!-- Invoice table — one continuous flow -->
    <div class="tbl" *ngIf="invoice">
      <div class="tbl__row">
        <span>{{ data?.job?.isVisitBasedShift ? 'Rate per visit' : 'Hourly rate' }}</span>
        <span>${{ invoice.rate }}</span>
      </div>
      <div class="tbl__row">
        <span>Time tracked</span>
        <span>{{ invoice.trackedHours }}</span>
      </div>
      <div class="tbl__row" *ngIf="invoice?.overtimeHours">
        <span>Overtime ({{ invoice.overtimeRate }}$/hr)</span>
        <span>{{ invoice.overtimeHours }}</span>
      </div>
      <div class="tbl__row" *ngIf="jobItem?.travelTime">
        <span>Travel time</span>
        <span>{{ utilService.formatTransitAllowance(jobItem?.travelTime) }}</span>
      </div>
      <div class="tbl__row" *ngIf="jobItem?.break?.unpaid">
        <span>Unpaid break</span>
        <span>{{ jobItem?.break.unpaid }}</span>
      </div>

      <div class="tbl__row tbl__row--bold">
        <span>Shift Amount</span>
        <span>${{ invoice.shiftAmount }}</span>
      </div>

      <div class="tbl__row tbl__row--deduct" *ngIf="invoice?.manualHrsReviewFee && invoice?.manualHrsReviewFee != '0.00'">
        <span>Manual hrs review</span>
        <span>–${{ invoice.manualHrsReviewFee }}</span>
      </div>
      <div class="tbl__row tbl__row--fee" *ngIf="invoice?.penaltyAmount && invoice?.penaltyAmount != '0.00'"
        [class.tbl__row--open]="invoice?.penaltyForLastShiftReason">
        <span>Fees</span>
        <span>–${{ invoice.penaltyAmount }}</span>
      </div>
      <!-- always shown, clamped to two lines until tapped -->
      <div class="tbl__reason" *ngIf="invoice?.penaltyForLastShiftReason"
        [class.tbl__reason--clamped]="!feeReasonOpen" (click)="feeReasonOpen = !feeReasonOpen">
        {{ invoice.penaltyForLastShiftReason }}
      </div>
      <div class="tbl__row tbl__row--deduct" *ngIf="invoice?.backgroundCheckAmount && invoice?.backgroundCheckAmount != '0.00'">
        <span>Background check</span>
        <span>–${{ invoice.backgroundCheckAmount }}</span>
      </div>
      <div class="tbl__row tbl__row--deduct" *ngIf="invoice?.staffyPayAdminFee && invoice?.staffyPayAdminFee != '0.00'">
        <span>StaffyPay fee</span>
        <span>–${{ invoice.staffyPayAdminFee }}</span>
      </div>
      <div class="tbl__row tbl__row--deduct" *ngIf="invoice?.serviceFee && invoice?.serviceFee != '0.00'">
        <span>Platform fee</span>
        <span>–${{ invoice.serviceFee }}</span>
      </div>
      <div class="tbl__row tbl__row--deduct" *ngIf="invoice?.serviceFeeTax && invoice?.serviceFeeTax != '0.00'">
        <span>Tax (Platform fee)</span>
        <span>–${{ invoice.serviceFeeTax }}</span>
      </div>

      <div class="tbl__row tbl__row--sub">
        <span>Sub-total</span>
        <span>${{ invoice.subTotal }}</span>
      </div>
      <div class="tbl__row" *ngIf="invoice?.contractorTax > 0">
        <span>Tax{{ invoice.taxName ? ' (' + invoice.taxName + ')' : '' }}</span>
        <span>${{ invoice.contractorTax }}</span>
      </div>

      <div class="tbl__total">
        <span>Total invoice amount</span>
        <span>${{ invoice.total }} <small>{{ invoice.currency }}D</small></span>
      </div>
    </div>

    <!-- Actions -->
    <div class="inv-actions">
      <button class="inv-btn inv-btn--pay"
        *ngIf="invoice?.status === 'unpaid' && invoice?.jobs[0].staffers[0].staffer.hasStaffyPayEnabled && !invoice?.hidePayNowButtonForOldInvoices"
        [disabled]="(invoice ? !invoice?.enablePayNowOption : false) || (!isInstantPayAvailable && !invoice?.scheduledDatePassed)"
        (click)="payStafferInvoice()">
        <i class="fas fa-bolt"></i>
        <ng-container *ngIf="invoice?.scheduledDatePassed">
          Pay now
        </ng-container>
        <ng-container *ngIf="isInstantPayAvailable && !invoice?.scheduledDatePassed">
          {{ invoice.applyInvoiceLabel }} {{ invoice.showStaffyPayFeeOnLabel ? '($' + utilService.calculateStaffyPayFee(invoice.subTotal) + ')' : '' }}
        </ng-container>
        <ng-container *ngIf="!isInstantPayAvailable && !invoice?.scheduledDatePassed">
          {{ earlyPayCooldownText }}
        </ng-container>
      </button>

      <button class="inv-btn inv-btn--outline"
        *ngIf="invoice?.status === 'unpaid' && !invoice?.jobs[0].staffers[0].staffer.hasStaffyPayEnabled"
        (click)="updateInvoiceMarkAsPaid()">
        {{ 'INVOICES.Mark as Paid' | translate }}
      </button>

      <button class="inv-btn inv-btn--dark" *ngIf="invoice" (click)="downloadInvoice()">
        <i class="fas fa-download"></i>
        Download Invoice
      </button>
    </div>

  </div>
</div>
